export default __webpack_public_path__ + "static/media/w-Logo.9132c563.png";